/* eslint-disable */

import { useTranslation as useUiTranslation } from "react-i18next";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { doc, setDoc } from "firebase/firestore";
import { X, MessageCircle, Store, Calendar, Link } from "lucide-react";
import Swal from "sweetalert2";
import { db } from "../../firebase";

const FoorchatConnection = ({ store }) => {
  const { t: uiT } = useUiTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [pageConnections, setPageConnections] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const products = useSelector((state) => state.ProductsReducer);

  // فحص الـ URL عند تحميل الصفحة لفتح المودال تلقائياً إذا كان هناك tokens
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    const pageid = params.get("pageid");
    const pagename = params.get("pagename");

    if (token && pageid) {
      const tokens = token.split(",");
      const pageIds = pageid.split(",");
      const pageNames = (pagename || "").split(",");

      const connections = pageIds.map((id, index) => ({
        pageId: id.trim(),
        name: pageNames[index]?.trim() || `صفحة ${index + 1}`,
        tokenFbChatbot: tokens[index]?.trim() || "",
        timeExpired: new Date(Date.now() + 60 * 24 * 60 * 60 * 1000),
        urlProduct: "",
        selectedProductId: "",
      }));

      setPageConnections(connections);
      setIsModalOpen(true);
    }
  }, []);

  const handleProductSelect = (pageIndex, productId) => {
    const updatedConnections = [...pageConnections];
    const selectedProduct = products.find((p) => p.id === productId);
    updatedConnections[pageIndex].selectedProductId = productId;
    updatedConnections[pageIndex].urlProduct = selectedProduct?.url || "";
    setPageConnections(updatedConnections);
  };

  const handleConnect = async () => {
    if (pageConnections.some((conn) => !conn.selectedProductId)) {
      Swal.fire({
        icon: "warning",
        title: uiT("Products.Table.confirmers.warning"),
        text: uiT("ui.pageProductMissing"),
        confirmButtonText: uiT("adduser.ok"),
        confirmButtonColor: "#9e65bb",
      });
      return;
    }

    const result = await Swal.fire({
      title: uiT("ui.connectPagesConfirm"),
      icon: "question",
      showCancelButton: true,
      confirmButtonText: uiT("ship.yes"),
      cancelButtonText: uiT("ship.no"),
      confirmButtonColor: "#9e65bb",
      cancelButtonColor: "#e87778",
    });

    if (result.isConfirmed) {
      setIsLoading(true);
      try {
        const storeRef = doc(db, "store", store.id);

        const foorchatData = {
          enabled: true,
          page: pageConnections.map((conn) => ({
            mode: "product",
            name: conn.name,
            pageId: conn.pageId,
            timeExpired: conn.timeExpired,
            tokenFbChatbot: conn.tokenFbChatbot,
            urlProduct: conn.urlProduct,
          })),
        };

        await setDoc(
          storeRef,
          {
            foorchat: foorchatData,
            foorchatPageId: pageConnections.map((conn) => conn.pageId),
          },
          { merge: true }
        );

        Swal.fire({
          icon: "success",
          title: uiT("ui.connectedSuccessfully"),
          text: uiT("ui.pagesConnectedCount", { value0: (pageConnections.length) }),
          confirmButtonText: uiT("adduser.ok"),
          confirmButtonColor: "#9e65bb",
        });

        setIsModalOpen(false);

        // إزالة البارامترات من الـ URL بعد الحفظ
        const url = new URL(window.location);
        url.searchParams.delete("token");
        url.searchParams.delete("pageid");
        url.searchParams.delete("shourl");
        window.history.replaceState({}, document.title, url);
      } catch (error) {
        console.error(error);
        Swal.fire({
          icon: "error",
          title: uiT("Products.ImportModal.error"),
          text: uiT("ui.connectionFailed"),
          confirmButtonText: uiT("adduser.ok"),
          confirmButtonColor: "#9e65bb",
        });
      } finally {
        setIsLoading(false);
      }
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setPageConnections([]);
  };

  return (
    <>
      {/* Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-hidden">
            {/* Header */}
            <div className="py-4 px-6 relative" dir="rtl">
              <div className="flex items-center justify-between mb-4 pb-2 border-b">
                <h2 className="text-[#9e65bb] font-bold text-xl flex-grow">
                  {uiT("ui.connectPages")}
                </h2>
                <button
                  onClick={closeModal}
                  className="p-2 hover:bg-gray-100 rounded-full transition-colors"
                >
                  <X className="text-[#9e65bb]" size={22} />
                </button>
              </div>
              <p className="text-gray-600 text-sm">{uiT("ui.pageProductHelp")}</p>
            </div>

            {/* Content */}
            <div
              className="px-6 max-h-[60vh] overflow-y-auto"
              dir="rtl"
              style={{
                scrollbarWidth: "thin",
                scrollbarColor: "#d8b4fe #f5f5f5",
              }}
            >
              {pageConnections.length === 0 ? (
                <div className="text-center py-8">
                  <MessageCircle
                    size={48}
                    className="mx-auto text-gray-400 mb-4"
                  />
                  <p className="text-gray-600">{uiT("ui.noPages")}</p>
                </div>
              ) : (
                <div className="space-y-6">
                  {/* معلومات الربط */}
                  <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                    <div className="flex items-center gap-2 text-blue-800 mb-2">
                      <Calendar size={20} />
                      <span className="font-semibold">{uiT("ui.connectionInfo")}</span>
                    </div>
                    <p className="text-blue-700 text-sm">
                      {uiT("ui.willConnect")} {pageConnections.length} {uiT("ui.pageConnectionDuration")}
                    </p>
                  </div>

                  {/* قائمة الصفحات */}
                  <div className="grid grid-cols-1 gap-4">
                    {pageConnections.map((connection, index) => (
                      <div
                        key={index}
                        className="border border-gray-200 rounded-xl overflow-hidden bg-gray-50"
                      >
                        {/* رأس الصفحة */}
                        <div className="p-4 bg-white border-b border-gray-100">
                          <div className="flex items-center gap-3">
                            <div className="bg-[#9e65bb] bg-opacity-10 p-2 rounded-lg">
                              <Store size={20} className="text-[#9e65bb]" />
                            </div>
                            <div className="flex-grow">
                              <h3 className="font-semibold text-gray-800 text-sm">
                                {uiT("ui.page")} {index + 1} - {connection.name}
                              </h3>
                              <p className="text-xs text-gray-600">
                                {uiT("ui.idLabel")} {connection.pageId}
                              </p>
                            </div>
                          </div>
                        </div>

                        {/* محتوى الصفحة */}
                        <div className="p-4 space-y-3">
                          <div className="flex items-center gap-2 text-sm text-gray-600">
                            <Calendar size={16} />
                            <span>
                              {uiT("ui.expiryLabel")}{" "}
                              {connection.timeExpired.toLocaleDateString("en")}
                            </span>
                          </div>

                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                              {uiT("ui.pageProductRequired")}
                            </label>
                            <select
                              value={connection.selectedProductId}
                              onChange={(e) =>
                                handleProductSelect(index, e.target.value)
                              }
                              className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#9e65bb] focus:border-[#9e65bb] bg-white text-sm"
                            >
                              <option value="">{uiT("ui.chooseProduct")}</option>
                              {products
                                ?.filter((product) => product.deleted !== 1)
                                .map((product) => {
                                  const name =
                                    product.name || product.title || "";
                                  const words = name.split(" ");
                                  const shortName =
                                    words.length > 8
                                      ? words.slice(0, 8).join(" ") + "..."
                                      : name;

                                  return (
                                    <option key={product.id} value={product.id}>
                                      {shortName}
                                    </option>
                                  );
                                })}
                            </select>
                          </div>

                          {connection.selectedProductId && (
                            <div className="bg-green-50 border border-green-200 rounded-lg p-3">
                              <div className="flex items-center gap-2 text-green-800">
                                <Link size={16} />
                                <span className="text-sm font-medium">
                                  {uiT("ui.productSelected")}
                                </span>
                              </div>
                              <p className="text-sm text-green-700 mt-1">
                                {
                                  products.find(
                                    (p) => p.id === connection.selectedProductId
                                  )?.name
                                }
                              </p>
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>

            {/* Footer */}
            {pageConnections.length > 0 && (
              <div
                className="border-t bg-gray-50 px-6 py-4 flex gap-3 justify-end"
                dir="rtl"
              >
                <button
                  onClick={closeModal}
                  className="px-5 py-2.5 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium"
                >
                  {uiT("annule")}
                </button>
                <button
                  onClick={handleConnect}
                  disabled={
                    isLoading ||
                    pageConnections.some((conn) => !conn.selectedProductId)
                  }
                  className={`px-5 py-2.5 rounded-lg text-white font-medium flex items-center shadow-sm ${
                    isLoading ||
                    pageConnections.some((conn) => !conn.selectedProductId)
                      ? "bg-[#9e65bb] opacity-70 cursor-not-allowed"
                      : "bg-[#9e65bb] hover:bg-[#814a9f] transition-colors"
                  }`}
                >
                  {isLoading ? (
                    <>
                      <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin ml-2"></div>
                      <span>{uiT("ui.connecting")}</span>
                    </>
                  ) : (
                    <>
                      <MessageCircle size={18} className="ml-2" />
                      <span>{uiT("foorchat.link_pages.title")}</span>
                    </>
                  )}
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default FoorchatConnection;
